import * as React from 'react';
import AppContainer from './AppContainer';
import {CONTENT_TYPE} from '../../Config/appConfig';

class ViewArchivedPolicyContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.VIEW_ARCHIVED_POLICY}/>
        );
    }
}

export default ViewArchivedPolicyContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/ViewArchivedPolicyContainer.tsx